import React from "react";
import s from './infoBlock.module.scss';
import img from './img/img.png';
import locales from '../../../content.json';

export const InfoBlock = () => {

  return(
    <div className={s.infoBlockWrappre}>
      <div className={s.infoBlock}>
        <img className={s.img} src={img} alt="image" />
        <h3 className={s.title} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_170}}>
        </h3>
        <p className={s.text}>
          {locales[window.userLang].payment_text_171}
        </p>
      </div>
    </div>
  );
};